import { createSelector } from 'reselect'
import { createMultipleStatusSelectors } from 'store/utils/selectorHelpers'
import types from './types'

const getStoreTemplatesState = (state) => state.storeTemplates

export const selectStoreTemplates = createSelector(
  [getStoreTemplatesState],
  (elements) => elements.data
)

export const {
  selectFetchStoreTemplatesStatus,
} = createMultipleStatusSelectors(types, getStoreTemplatesState)



// WEBPACK FOOTER //
// ./src/store/storeTemplates/selectors.js